import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '300px',
  },

  // Filtros
  cardFiltros: {
    marginBottom: theme.spacing(3),
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    borderRadius: '8px',
    backgroundColor: theme.palette.background.paper,
  },
  cardHeader: {
    padding: theme.spacing(1.5, 2),
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
  cardContent: {
    padding: theme.spacing(2, 3, 3, 3),
  },
  cardActions: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
  },
  grupoFiltros: {
    marginBottom: theme.spacing(1),
  },
  grupoTitle: {
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    fontSize: '0.75rem',
    borderBottom: `2px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(0.5),
  },
  submitButton: {
    backgroundColor: '#595959',
    color: 'white',
    minWidth: '120px',
    '&:hover': {
      backgroundColor: '#404040',
    },
  },
}))

export default useStyles
